import {
  serviceList,
  userMiniServiceList,
  checkAppServiceName
} from "@/services/service";
import {
  SET_DEFAULT_STATE_SERVICE,
  SET_TYPE_SERVICE,
  UPDATE_SERVICE_NAME,
  BLUR_INPUT_SERVICE_NAME,
  // ready apps
  SET_READY_APPS_LIST,
  SELECT_READY_APPS,
  SET_READY_APP_SELECTED_VERSION,
  SET_USER_DB_LIST,
  SET_USER_DB_SELECTED,
  // custom apps
  SET_CUSTOM_APPS_LIST,
  SELECT_CUSTOM_APPS,
  SET_CUSTOM_APP_SELECTED_VERSION,
  // databases
  SET_DATABASE_LIST,
  SELECT_DATABASE,
  SET_DATABASE_SELECTED_VERSION
} from "../mutation-types";

export default {
  [SET_DEFAULT_STATE_SERVICE]: state => {
    //Database
    state.databaseList = [];
    state.databaseSelectedVersion = "";
    state.databaseSelectedItem = {};
    state.databaseLoading = false;
    state.databaseErrorMessages = "";
    //Ready Application
    state.readyAppsList = [];
    state.readyAppsSelectedVersion = "";
    state.readyAppsSelectedItem = {};
    state.readyAppsLoading = false;
    state.readyAppsErrorMessages = "";
    //Custom Application
    state.customAppsList = [];
    state.customAppsSelectedVersion = "";
    state.customAppsSelectedItem = {};
    state.customAppsLoading = false;
    state.customAppsErrorMessages = "";
    // Common Service
    state.userDbList = [];
    state.serviceName = { value: "", error: "" };
    state.validServiceName = null;
    state.typeService = "";
  },
  [SET_TYPE_SERVICE]: (state, type) => {
    state.typeService = type;
  },
  [UPDATE_SERVICE_NAME]: (state, serviceName) => {
    const reg = /^[A-Za-z0-9_]*$/;
    if (serviceName === "") {
      state.serviceName.error = "شناسه الزامی است.";
      state.validServiceName = false;
    } else {
      if (!reg.test(serviceName)) {
        state.serviceName.error = "شناسه وارد شده صحیح نیست.";
        state.validServiceName = false;
      } else {
        state.serviceName.error = "";
        state.validServiceName = true;
        state.serviceName.value = serviceName;
      }
    }
  },
  [BLUR_INPUT_SERVICE_NAME]: async (state, serviceName) => {
    if (state.validServiceName) {
      const [error, data] = await checkAppServiceName({
        name: serviceName
      });
      if (!error) {
        if (data.apiStatus === 200) {
          if (data.apiData.isDuplicated) {
            state.serviceName.error = "شناسه تکراری است";
            state.validServiceName = false;
          } else {
            state.serviceName.error = "";
            state.validServiceName = true;
          }
        }
      }
    }
  },
  /***************Ready Aplication***************/
  [SET_READY_APPS_LIST]: async state => {
    state.readyAppsLoading = true;
    const [error, data] = await serviceList("2");
    if (error) {
      state.readyAppsErrorMessages = error;
      state.readyAppsLoading = false;
    } else {
      if (data.apiStatus === 200) {
        state.readyAppsList = [...data.apiData];
        state.readyAppsList.map((app, i) => {
          app["id"] = i;
          app["selected"] = false;
          app["picture"] = app.picture.replace("files", "file");
        });
        state.readyAppsLoading = false;
      } else {
        state.readyAppsErrorMessages = data.apiErrors;
        state.readyAppsLoading = false;
      }
    }
  },
  [SELECT_READY_APPS]: (state, id) => {
    let temp = [...state.readyAppsList];
    temp.map(app => {
      if (app.id == id) {
        app.selected = true;
        state.readyAppsSelectedItem = { ...app };
        state.readyAppsSelectedVersion = app.versions[0].id;
      } else {
        app.selected = false;
      }
    });
    state.readyAppsList = [...temp];
  },
  [SET_READY_APP_SELECTED_VERSION]: (state, version) => {
    state.readyAppsSelectedVersion = version;
  },
  [SET_USER_DB_LIST]: async state => {
    const [error, data] = await userMiniServiceList("1");
    if (!error) {
      if (data.apiStatus === 200) {
        state.userDbList = [...data.apiData];
      } else {
        console.log(data.apiErrors);
      }
    }
  },
  [SET_USER_DB_SELECTED]: (state, databaseID) => {
    state.userDbSelected = databaseID;
  },
  /***************Custom Aplication***************/
  [SET_CUSTOM_APPS_LIST]: async state => {
    state.customAppsLoading = true;
    const [error, data] = await serviceList("3");
    if (error) {
      state.customAppsErrorMessages = error;
      state.customAppsLoading = false;
    } else {
      if (data.apiStatus === 200) {
        state.customAppsList = [...data.apiData];
        state.customAppsList.map((app, i) => {
          app["id"] = i;
          app["selected"] = false;
          app["picture"] = app.picture.replace("files", "file");
        });
        state.customAppsLoading = false;
      } else if (data.apiStatus === 500) {
        state.customAppsErrorMessages = data.apiErrors;
        state.customAppsLoading = false;
      }
    }
  },
  [SELECT_CUSTOM_APPS]: (state, id) => {
    let temp = [...state.customAppsList];
    temp.map(app => {
      if (app.id == id) {
        app.selected = true;
        state.customAppsSelectedItem = { ...app };
        state.customAppsSelectedVersion = app.versions[0].id;
      } else {
        app.selected = false;
      }
    });
    state.customAppsList = [...temp];
  },
  [SET_CUSTOM_APP_SELECTED_VERSION]: (state, version) => {
    state.customAppsSelectedVersion = version;
  },
  /***********************************************/
  [SET_DATABASE_LIST]: async state => {
    state.databaseLoading = true;
    const [error, data] = await serviceList("1");
    if (error) {
      state.databaseErrorMessages = error;
      state.databaseLoading = false;
    } else {
      if (data.apiStatus === 200) {
        state.databaseList = [...data.apiData];
        state.databaseList.map((app, i) => {
          app["id"] = i;
          app["selected"] = false;
          app["picture"] = app.picture.replace("files", "file");
        });
        state.databaseLoading = false;
      } else {
        state.databaseErrorMessages = data.apiErrors;
        state.databaseLoading = false;
      }
    }
  },
  [SELECT_DATABASE]: (state, id) => {
    let temp = [...state.databaseList];
    temp.map(app => {
      if (app.id == id) {
        app.selected = true;
        state.databaseSelectedItem = { ...app };
        state.databaseSelectedVersion = app.versions[0].id;
      } else {
        app.selected = false;
      }
    });
    state.databaseList = [...temp];
  },
  [SET_DATABASE_SELECTED_VERSION]: (state, version) => {
    state.databaseSelectedVersion = version;
  }
};
